<error>
  <p i18n="@@front.noWallet.error">We are having an issue with creating your wallet, please try again in a minute</p>
  <a routerLink="/dashboard" class="btn btn-primary" i18n="@@front.noWallet.button">Try Again</a>
</error>